import { Component, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { Inspection, InspectionPlugin } from '../../shared/models/index';
import { ModalComponent } from '../../modal/modal.component';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
  selector: 'plugin-edit',
  templateUrl: './edit.component.html',
  standalone: false
})
export class PluginEditComponent extends BaseModalPageComponent implements OnInit {
  @Input() public plugin: InspectionPlugin;
  @Input() public processing;
  @Output() public toggleSavePlugin: EventEmitter<any> = new EventEmitter();
  @Output() public toggleCancel: EventEmitter<any> = new EventEmitter();
  editForm: UntypedFormGroup;
  inspection: Inspection;

  @ViewChild('synchronizationModal', { static: true })
  synchronizationModal: ModalComponent;

  public synchronizationOptions: any[] = [
    { key: 'common.select.default', value: null },
    { key: 'plugins.states.yes', value: true },
    { key: 'plugins.states.no', value: false }
  ];

  constructor(location: Location, private translationService: TranslateService) {
    super(location);
  }

  ngOnInit(): void {
    this.inspection = this.plugin.inspection;
    this.initForm();
  }

  public updatePlugin(model: any) {
    this.plugin.description = model.description;
    this.plugin.slotPath = model.slotPath;
    this.plugin.synchronizationEnabled = model.synchronizationEnabled;
    this.toggleSavePlugin.emit(this.plugin);
  }

  public cancel() {
    this.toggleCancel.emit();
  }

  public openSynchronizationSelector(): void {
    this.synchronizationOptions.forEach((option) => (option.label = this.translationService.instant(option.key)));
    const currentValue = this.editForm.controls['synchronizationEnabled'].value;
    this.openSelector(this.synchronizationModal, this.synchronizationOptions, currentValue);
  }

  public selectSynchronizationMenu(item: any) {
    this.editForm.controls['synchronizationEnabled'].setValue(item.value?.value ?? null);
  }

  public onSynchronizationMenuClose(e: any) {
    this.editForm.controls['synchronizationEnabled'].markAsTouched();
  }

  get synchronizationLabel(): string {
    const value = this.editForm.controls['synchronizationEnabled'].value;
    const option = this.synchronizationOptions.find((opt) => opt.value === value);
    return option ? option.key : 'common.select.default';
  }

  initForm() {
    const regex = new RegExp(/<br\s*[\/]?>/gi);
    this.editForm = new UntypedFormGroup({
      description: new UntypedFormControl(this.plugin.description.replace(regex, '\n')),
      slotPath: new UntypedFormControl(this.plugin.slotPath),
      synchronizationEnabled: new UntypedFormControl(this.plugin.synchronizationEnabled)
    });
  }
}
